import styled from 'styled-components';

import { Col, Row } from '@components/formStyles';

export const MainImage = styled.img`
  width: 592px;
  height: 382px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X_S})`} {
    width: 100vw;
    height: 206px;
  }
`;

export const StyledRow = styled(Row)`
  cursor: pointer;

  & img {
    object-fit: cover;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X_S})`} {
    width: 100%;
  }
`;

export const MainImageWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

export const StyledCol = styled(Col)`
  margin-left: 15px;
`;

export const BottomImage = styled.div`
  margin-top: 15px;
`;

export const LastImage = styled.div`
  margin-top: 15px;
  position: relative;
  display: flex;
  justify-content: center;
  &:before {
    position: absolute;
    display: block;
    transform: translateX(-50%);
    left: 50%;
    width: 100%;
    height: 100%;
    background: rgba(47, 49, 55, 0.6);
    border-radius: 8px;
    content: '';
  }
`;

export const ViewGalleryButton = styled.button`
  position: absolute;
  border-style: none;
  bottom: 110px;
  color: ${(p) => p.theme.palette.white};
  font-weight: bold;
  font-size: 18px;
  margin-left: 30px;
  background: ${(p) => p.theme.palette.eclipse};
  border-radius: 2px;
  cursor: pointer;
  padding: 10px 20px;
  height: 42px;
  display: flex;
  align-items: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: none;
  }
`;

export const ShowAllImagesText = styled.span`
  color: ${({ theme }) => theme.palette.white};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  position: absolute;
  display: flex;
  align-self: center;
`;
